import React from "react";
import BaseInfoIcon from "../../icons/base-info.icon";
import styles from "./index.module.scss";

interface InfoBannerProps {
  message: string;
}

const InfoBanner = ({ message }: InfoBannerProps) => {
  return (
    <div
      className={styles.banner}
      role="alert"
      aria-live="polite"
    >
      <div className={styles.iconContainer}>
        <BaseInfoIcon fill="currentColor" />      
      </div>

      <div className={styles.content}>
        <p className={styles.text}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default InfoBanner;